module.exports = __webpack_public_path__ + "img/ok.6dcbd583.png";